export enum HoardingsLocale {
  DEFAULT = 'AA',
}
